import React from "react";
import "./style.css"; // You'll need to create this CSS file

const SpinnerLoader: React.FC = () => {
  return (
    <div className="spinner">
      <div className="double-bounce1"></div>
      <div className="double-bounce2"></div>
    </div>
  );
};

export default SpinnerLoader;
